import api from '../config/api';

export interface Daara {
  id: number;
  titre: string;
  description: string;
  jour: 'lundi' | 'mardi' | 'mercredi' | 'jeudi' | 'vendredi' | 'samedi' | 'dimanche';
  photo_principale?: string;
  fichier_pdf?: string;
  audio?: string;
  audio_cours?: string;
  nombre_vues: number;
  nombre_likes: number;
  nombre_commentaires?: number;
  is_liked?: boolean;
  notification_sent?: boolean;
  url_slug: string;
  section?: 'VCN' | 'HDR' | 'SANTE';
  created_at: string;
  updated_at: string;
  created_by?: {
    id: number;
    username: string;
    first_name?: string;
    last_name?: string;
  };
}

export interface DaaraComment {
  id: number;
  daara: number;
  user: {
    id: number;
    username: string;
    first_name?: string;
    last_name?: string;
  };
  contenu: string;
  approuve: boolean;
  created_at: string;
  updated_at: string;
}

export interface DaaraListParams {
  jour?: string;
  search?: string;
  section?: string;
  ordering?: string;
  page?: number;
  page_size?: number;
}

export const daaraService = {
  getAll: async (params?: DaaraListParams): Promise<{ results: Daara[]; count: number; next?: string; previous?: string }> => {
    const response = await api.get('/daara/daaras/', { params });
    // S'assurer que la réponse a la structure attendue pour la pagination
    if (response.data && (response.data.results !== undefined || Array.isArray(response.data))) {
      return response.data;
    }
    // Si la réponse est un tableau simple, le transformer en format paginé
    if (Array.isArray(response.data)) {
      return {
        results: response.data,
        count: response.data.length,
      };
    }
    return { results: [], count: 0 };
  },
  
  getById: async (idOrSlug: number | string): Promise<Daara> => {
    // idOrSlug peut être un ID numérique ou un url_slug (titre-id)
    const response = await api.get(`/daara/daaras/${idOrSlug}/`);
    return response.data;
  },
  
  like: async (idOrSlug: number | string): Promise<{ liked: boolean; message: string }> => {
    const response = await api.post(`/daara/daaras/${idOrSlug}/like/`);
    return response.data;
  },
  
  commenter: async (idOrSlug: number | string, contenu: string): Promise<DaaraComment> => {
    const response = await api.post(`/daara/daaras/${idOrSlug}/commenter/`, { contenu });
    return response.data;
  },
  
  getCommentaires: async (idOrSlug: number | string): Promise<DaaraComment[]> => {
    const response = await api.get(`/daara/daaras/${idOrSlug}/commentaires/`);
    return response.data;
  },
};

